import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Label
} from 'recharts';
import { Box, Typography, Paper } from '@mui/material';

interface IzinGrafigiProps {
  kullanilan: number | string;
  kalan: number | string;
  labelPosition?: 'center' | 'under';
}

const IzinGrafigi: React.FC<IzinGrafigiProps> = ({
  kullanilan,
  kalan,
  labelPosition = 'center'
}) => {
  const k = Number(kullanilan) || 0;
  const r = Number(kalan) || 0;

  const toplam = k + r;
  const yuzde = toplam > 0 ? ((k / toplam) * 100).toFixed(2) : '0.00';

  const data = [
    { name: 'Kullanılan', value: k },
    { name: 'Kalan', value: r }
  ];

  const COLORS = ['#95A5A6', '#2E86C1'];

  if (toplam === 0) {
    return (
      <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
        <Typography variant="subtitle2" align="center" sx={{ mb: 2 }}>
          Kullanılan İzin
        </Typography>
        <Box
          sx={{
            height: 220,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Gösterilecek izin verisi yok
          </Typography>
        </Box>
      </Paper>
    );
  }

  const pieCy = labelPosition === 'center' ? '50%' : '45%';

  const containerHeight = labelPosition === 'under' ? 240 : 220;

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle2" align="center" sx={{ mb: 2 }}>
        Kullanılan İzin
      </Typography>

      <Box sx={{ width: '100%', height: containerHeight }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy={pieCy}
              innerRadius={55}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
              labelLine={false}
              isAnimationActive={false}
            >
              {labelPosition === 'center' && (
                <Label
                  value={`%${yuzde}`}
                  position="center"
                  style={{
                    fontSize: 18,
                    fontWeight: 700,
                    fill: '#34495E',
                    textAnchor: 'middle'
                  }}
                />
              )}

              {data.map((_, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index]}
                  stroke="#FFFFFF"
                  strokeWidth={1}
                />
              ))}
            </Pie>

            <Tooltip
              formatter={(value?: number | string) => {
                const num = Number(value);
                return Number.isNaN(num) ? '' : `${num.toFixed(2)} gün`;
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>

      {labelPosition === 'under' && (
        <Box sx={{ mt: 1, textAlign: 'center' }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
            %{yuzde}
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          mt: 1,
          display: 'flex',
          gap: 2,
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, bgcolor: COLORS[0], borderRadius: 1 }} />
          <Typography variant="caption">Kullanılan: {k.toFixed(2)} gün</Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ width: 12, height: 12, bgcolor: COLORS[1], borderRadius: 1 }} />
          <Typography variant="caption">Kalan: {r.toFixed(2)} gün</Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default IzinGrafigi;
